import React from 'react'
import Hero from '../Sections/Blog/hero'
import LatestArticles from '../Sections/Blog/LatestArticle'
import NewsletterSection from '../Sections/Blog/NewsLetter'
import BlogSection from '../Sections/Blog/BlogSection'

function MainBlog() {
  return (
    <>
    <Hero/>
    <LatestArticles/>
    <NewsletterSection/>
    <BlogSection/>
    </>
  )
}

export default MainBlog
